import Reveal from "@/components/Reveal";
import { DiscussButton, ExploreButton } from "@/components/Ctas";

const CtaBand = ({
    title = "Have a space in mind?",
    text = "One conversation is enough to begin. Tell us what you are planning — property, interiors, furniture, or all three.",
}) => (
    <section className="bg-charcoal" data-testid="cta-band">
        <div className="mx-auto max-w-7xl px-6 py-20 sm:px-12 lg:px-20 lg:py-28">
            <Reveal>
                <p className="text-xs font-semibold uppercase tracking-[0.25em] text-bronze-light">
                    Begin the conversation
                </p>
                <h2 className="mt-4 max-w-2xl font-serif text-3xl tracking-tight text-cream sm:text-4xl lg:text-5xl">
                    {title}
                </h2>
                <p className="mt-5 max-w-xl text-base leading-relaxed text-cream/70">{text}</p>
                <div className="mt-9 flex flex-wrap gap-4">
                    <DiscussButton testid="cta-band-discuss" />
                    <ExploreButton testid="cta-band-explore" />
                </div>
            </Reveal>
        </div>
    </section>
);

export default CtaBand;
